//顶部logo
<template>
    <div class="div_logo-outer">
    <div class="div-logo">
        <div class="div-logo-left">
            <img :src="logo_src"
            class="div-logo-left_img">
        </div>
        <div class="div-logo-right">股票代码：833665</div>
    </div>
    </div>
</template>
<script>
    import logo_img from '@/assets/img/logo.png'
    export default{
        data () {
        return {
            "logo_src": logo_img
            }
        }
    }
    
</script>

<style>
    .div_logo-outer{
        margin-bottom: 5.25rem;
    }
    .div-logo {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items:center;
        position: fixed;
        background-color: #fff;
        top: 0px;
        z-index: 999;
        margin-top: 0px;
        width:100%;
    }
    .div-logo-left{
        width: 33%;
        margin-left: 24px;
    }
    .div-logo-left img{
        width: 100%;
    }
    .div-logo-right{
        /* width: 27.6%; */
        font-size: 1.5rem;
        margin-right: 24px;
        text-align: center;
        height: 100%;
        font-weight: 500;
        line-height: 33.6px;
    }


</style>